import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { HttpService } from 'src/app/services/http/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IAppState } from 'src/app/interfaces/app-state';
import { Spinkit } from 'ng-http-loader';
import { IPageData } from 'src/app/interfaces/page-data';
import { BasePageComponent } from '../../base-page';
import * as PageActions from '../../../store/actions/page.actions';
import { HttpErrorResponse } from '@angular/common/http';
import { Options } from 'ng5-slider';
import { MatSnackBar } from '@angular/material/snack-bar';
import {Location} from '@angular/common';
@Component({
  selector: 'app-mypreference',
  templateUrl: './mypreference.component.html',
  styleUrls: ['./mypreference.component.scss']
})
export class MypreferenceComponent extends BasePageComponent implements OnInit, OnDestroy {

  pageData: IPageData;
 
  public spinkit = Spinkit;
  restoID
  ids
  UserCondition
  token
  tableids
  dishId
  allreviewData 
  errorMessage 
  allergenreview =[]
  listoffriends  =[];
  referalcode: any;
  Baselinkshare: string;
  user_preferences: any;
  user_preference_spice: any;
  userIngredients: any;
  userDislikes: any;
  userAllergens: any;
  userDietary: any[] = [];
  allergensarry=[];
  dietaryarry =[];
  ingredientbind= [];
  userDislikesbind =[];
  user_ingredients:[];
  alldietary = [];
  allAllergens =[];

  datas = [
    { "label": "1", "value": "1" },
    { "label": "2", "value": "2" },
    { "label": "3", "value": "3" },
    { "label": "4", "value": "4" }
  ]
  iconmenu = './assets/img/menu.svg';
  iconAtvmenu = './assets/img/greymenu.svg';

  iconcart = './assets/img/green_cart.svg';
  iconAtvcart = './assets/img/cart.svg';

  iconorder = './assets/img/green_orders.svg';
  iconAtvorder = './assets/img/order.svg';

  iconprofile = './assets/img/greenprofile.svg';
  iconAtvprofile = './assets/img/profile.svg';
  constructor(store: Store<IAppState>,
    public httpSv: HttpService,
    private router:Router,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private _location: Location
    ) { 
    super(store, httpSv);

    this.pageData = {
      title: '',
      loaded: true,
      breadcrumbs: [
        {
          title: '',
          route:'preference'
        }
      ]
    };   
  } 

  spiceTollerence = 0;
  values: number = 0;
  options: Options = {
    floor: 0,
    ceil: 4
  };
  ngOnInit() {
    this.restoID=sessionStorage.getItem("restoId")
    this.token=sessionStorage.getItem('access_token')
    this.ids=sessionStorage.getItem('restoIds')
    this.tableids =sessionStorage.getItem('tableIds')
    this.dishId = sessionStorage.getItem('DishId')
    this.route.queryParams.subscribe(params => {
    this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
});

if (this.UserCondition) {
  this.getAllAllergens(this.restoID);
  this.getAllRestoDietary(this.restoID);
  this.getAllDislikesAndFavoritesIngredients()
}
    this.pageData ? this.store.dispatch(new PageActions.Set(this.pageData)) : null;
  }

  // Function to get all the allergens of the restaurant
  getAllAllergens(restoID) {
    this.httpSv.getRestaurantAllergensWithoutId().subscribe((res: any) => {
      if (res['status'] == "TRUE") {
        this.allAllergens = res['result'].data;
      }
      this.FetchUserPrefernces()
    }, (err: any) => {
      console.log(err);
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }

  ngOnDestroy() {
    this.store.dispatch(new PageActions.Reset());
  }

  backToFoodMenu() {
    this._location.back();
    // this.router.navigate(['/horizontal/food-menu'])
  }

  logout() {
		this.httpSv.logouts(this.token).subscribe(
			response => {
				if (response['status'] == true) {
					sessionStorage.clear();
					this.router.navigate(['public/resto'], {
						queryParams: {
							id: this.ids,
							table_id: this.tableids
						}
					});
          window.location.reload()
				} 
			}
		)
	}
 
  // Function to get all the ingredients
  getIngredients() {
    this.httpSv.getIngredients().subscribe(
      res => {
        if (res['status'] == true) {
          this.user_ingredients = res['result']
        }
      },(err:any)=> {
        console.log(err);
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }

  // Function to get all the dislikes and favourite Ingredients
  getAllDislikesAndFavoritesIngredients() {
    this.httpSv.getDislikesAndFavorites().subscribe((res: any) => {
      if (res['status'] == 'TRUE') {
        this.user_ingredients = res['result'];
        // this.dislikeIngredientsArray = res['result'];
      }
    }, (err: any) => {
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
      console.log(err);
    })
  }

  // Function to get all the dietary of the restaurant
  getAllRestoDietary(restoID) {
    this.httpSv.getRestaurantDietrayWithoutId().subscribe((res: any) => {
      if (res['status'] == 'TRUE') {
        this.alldietary = res['result'].data;
      }
    }, (err: any) => {
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
      console.log(err);
    })
  }
  
  backtodetails(){
    this.router.navigate(['/horizontal/userprofile'])
  }
  algns =[]

  load : boolean = false
  fetchedUserPreferences

  // Function to get all user preferences of the user
  FetchUserPrefernces() {
    this.httpSv.getUserPreferences().subscribe((res:any)=> {
      if (res['status'] == "TRUE") { 
        this.fetchedUserPreferences = res['result'].data;
        this.userAllergens = this.fetchedUserPreferences.user_preference_allergens;
        this.userDietary = this.fetchedUserPreferences.user_preference_dietary;
        this.userIngredients = this.fetchedUserPreferences.user_preference_ingredient
        this.userDislikes =  this.fetchedUserPreferences.user_preference_dislike
        this.spiceTollerence = this.fetchedUserPreferences.user_preference_spice;
        this.allAllergens.forEach(element => {
          this.algns.push(element.allergens_id)
        });
        if (Array.isArray(this.userAllergens)) {
          this.userAllergens.forEach(element => {
            this.allergensarry.push(element.allergens_id)
          })
        }
        else {
          this.allergensarry = []
        }
        if (Array.isArray(this.userDietary)) {
          this.userDietary.forEach(element => {
            this.dietaryarry.push(element.diet_preference_id)
          })
        }
        else {
          this.userDietary = []
        }
        if (Array.isArray(this.userIngredients)) {
          this.userIngredients.forEach(element => {
            this.ingredientbind.push(element.sub_ingredient_id)
          });
        }
        else {
          this.userIngredients = []
        }
        if (Array.isArray(this.userDislikes)) {
          this.userDislikes.forEach(element => {
            this.userDislikesbind.push(element.sub_ingredient_id)
          });
        }
        else {
          this.userDislikes = []
        }
        this.load = true;
      }
    },(err:any)=> {
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
      console.log(err);
    })
   
  }

  // Function to update the user Preferences
  updateUserPreferences() {
    let preferenceObj = {
      allergens : this.allergensarry,
      dietary :this.dietaryarry,
      ingredients:this.ingredientbind,
      dislikes:this.userDislikesbind,
      spice:this.spiceTollerence,
      screen :"profile"
    }
    this.httpSv.postUserPreferences(preferenceObj).subscribe((res:any)=> {
     if(res['status'] == 'TRUE') {
      this._snackBar.open("Food Preferences Updated !");
      setTimeout(() => {
        this._snackBar.dismiss();
      }, 2000);

      setTimeout(() => {
        this._location.back();
      }, 2500);
     }
    },(err:any)=>{
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
      console.log(err);
    })
  }
}
